import { NgModule } from '@angular/core';
import { HomePageEventBuilder } from './home-page-event.builder';

@NgModule({})
export class HomePageEventModule {
  constructor(_homePageEventBuilder: HomePageEventBuilder) {}
}
